import React from 'react';
import { DeviceTypeParameterFieldProps } from './TextParameterField';

const ImageParameterField = (props: DeviceTypeParameterFieldProps) => {
  return (
    <img style={{ maxWidth: '50%' }} src={props.parameter.label} alt={props.parameter.identifier} />
  );
};
export default ImageParameterField;
